import styled from 'styled-components';

export const Container = styled.div`
  min-width: 70vw;
  width: 70vw;
  min-height: 50vh;
  height: 50vh;
  height: 46%;
  display: flex;
`;

export const ImageContainer = styled.div`
  width: 30%;
  height: auto;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    border-radius: 1.11rem 0 0 1.11rem;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ChallengeDetailsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 2.44rem;
  gap: 1rem;
  position: relative;

  > button {
    position: absolute;
    right: 1.2rem;
    top: 2rem;
  }

  > h1 {
    text-align: center;
    font-family: 'RedHatDisplay-Bold';
    font-size: 1.2rem;
    color: #1e88e5;
  }

  > p {
    font-size: 1rem;
    color: #323232;
  }

  > ul {
    font-size: 0.8rem;
    color: #323232;
  }

  > span {
    font-family: 'RedHatDisplay-Medium';
    font-size: 0.8rem;
    color: #000;
  }
`;

export const Footer = styled.div`
  margin-top: auto;
  display: flex;
  width: 100%;
  justify-content: space-between;

  > .primary-button {
    height: 1.8rem;
    padding: 0.8rem;
    font-family: 'RedHatDisplay-Bold';
    font-size: 0.8rem;
    border-radius: 0.6rem;
    box-shadow: 0px 3px 15px rgba(255, 152, 0, 0.3);

    > svg {
      margin-right: 0.3rem;
    }
  }
`;

export const CountUsers = styled.div`
  display: flex;
  align-items: center;

  > svg {
    margin-right: 0.4rem;
  }

  font-family: 'RedHatDisplay-Medium';
  font-size: 0.8rem;
  color: #000;
`;
